var O = Object.defineProperty;
var W = (e, n, i) => n in e ? O(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i;
var g = (e, n, i) => W(e, typeof n != "symbol" ? n + "" : n, i);
const ve = () => {
  var n;
  const e = (n = document.querySelector("html")) == null ? void 0 : n.getAttribute("lang");
  if (e != null)
    return e;
}, Pe = () => "pathname" in window.location ? window.location.pathname : void 0;
function Le(e) {
  return e != null && document.querySelector(e) != null ? "challenger" : "control";
}
const Ie = () => {
  var n;
  const e = (n = document.querySelector('meta[name="version"]')) == null ? void 0 : n.getAttribute("content");
  if (e != null)
    return e;
}, X = () => {
  const e = navigator.userAgent.toLowerCase();
  return /fban|fbav|facebookexternalhit|fbios|fbid|fbsn/i.test(e);
}, L = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
) ? "Mobile" : "Desktop", Ae = () => "height" in window.screen ? window.screen.height : void 0, Ce = () => "width" in window.screen ? window.screen.width : void 0, D = "meta[name=csrf-token]";
let y;
function M() {
  if (y != null)
    return y;
  const e = document.querySelector(D);
  if (e != null) {
    const n = e.getAttribute("content");
    if (n != null)
      return y = n, y;
  }
  return "";
}
function S(e, n, i, t, a) {
  const o = new XMLHttpRequest();
  o.open(e, n, !0), o.onload = () => {
    o.status >= 200 && o.status < 400 && JSON.parse(o.response);
  }, o.onerror = (r) => {
  }, e === "POST" && (o.setRequestHeader(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  ), o.setRequestHeader("x-csrf-token", M())), o.send(i);
}
const b = (e) => Object.keys(e).map((n) => `${encodeURIComponent(n)}=${encodeURIComponent(e[n])}`).join("&"), R = (e, n) => {
  const i = b(n), t = new XMLHttpRequest();
  return t.open("GET", ` ${e}?${i}`, !0), t.setRequestHeader(
    "Content-type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  ), t.send();
}, B = (e) => {
  const n = Object.keys(e);
  let i = n.length;
  const t = new Array(i);
  for (; i-- > 0; ) t[i] = [n[i], e[n[i]]];
  return t;
}, Z = () => ({
  userAgent: navigator.userAgent,
  facebook: X(),
  performanceTimeline: "timing" in window.performance,
  DOMHighResTimeStamp: "now" in window.performance,
  networkInformation: "connection" in window.navigator,
  navigationEntry: E("navigation"),
  resourceTimingEntry: E("resource"),
  webShare: "share" in window.navigator,
  visibilityChange: "visibilityState" in document,
  pageHide: "onpagehide" in window,
  fetch: "fetch" in window,
  sendBeacon: "sendBeacon" in window.navigator,
  webSocket: WebSocket != null,
  localStorage: localStorage.length != null,
  performanceObserver: window.PerformanceObserver != null,
  mutationObserver: window.MutationObserver != null,
  intersectionObserver: window.IntersectionObserver != null,
  performancePaintTiming: E("paint")
}), E = (e) => {
  if ("getEntriesByType" in performance) {
    const n = window.performance.getEntriesByType(e);
    return n != null && n.length > 0;
  } else
    return !1;
}, Fe = () => {
  const e = Z();
  return S(
    "POST",
    "/2",
    b(e)
  );
}, Y = () => {
  const e = document.querySelector("[data-metrics__body]");
  if (e != null) {
    const n = Array.prototype.slice.call(e.children), i = document.querySelector("[data-metrics__content]");
    if (i != null) {
      const c = Array.prototype.slice.call(
        i.children
      );
      n.push(c);
    }
    const t = n.reduce(
      (c, s) => c.concat(s),
      []
    );
    [0.25, 0.5, 0.75].forEach(function(c) {
      const s = Math.round(t.length * c), m = t[s], p = (c.toString().replace(/^[0.]+/, "") + "0").slice(0, 2);
      m.dataset.metrics = p;
    });
    const o = t.length - 1, r = t[o];
    r.dataset.metrics = "100";
  }
}, ke = function() {
  Y();
  const e = document.querySelectorAll(
    "[data-metrics]"
  ), n = Array.prototype.slice.call(
    e
  ), i = function(t) {
    new IntersectionObserver(function(o, r) {
      o.forEach(function(c) {
        var s;
        if (c.isIntersecting) {
          const m = {
            locale: window.OP_METRICS.locale,
            pathname: document.location.pathname,
            referrer: window.OP_METRICS.referrer,
            screenHeight: window.OP_METRICS.screen_height,
            screenWidth: window.OP_METRICS.screen_width,
            version: window.OP_METRICS.site_version,
            template: window.OP_METRICS.template,
            elementSelector: "Metrics-" + ((s = c.target) == null ? void 0 : s.getAttribute("data-metrics")),
            timeSeen: c.time.toString()
          };
          r.disconnect(), S("POST", "/3", b(m));
        }
      });
    }).observe(t);
  };
  n.forEach(i);
}, j = () => typeof window.performance.getEntriesByType == "function" && window.performance.getEntriesByType("navigation") != null && window.performance.getEntriesByType("navigation").length > 0 ? window.performance.getEntriesByType("navigation")[0] : typeof window.performance.timing == "object" && window.performance.timing != null ? window.performance.timing : void 0;
function U() {
  if (typeof navigator == "object") {
    const e = navigator.connection ?? navigator.mozConnection ?? navigator.webkitConnection ?? navigator.msConnection;
    return e != null ? {
      effectiveType: e.effectiveType,
      rtt: e.rtt,
      saveData: e.saveData
    } : void 0;
  } else
    return;
}
const J = () => {
  if (typeof window.performance.getEntriesByType == "function" && window.performance.getEntriesByType("paint") != null && window.performance.getEntriesByType("paint").length > 0)
    return performance.getEntriesByType("paint").reduce((i, t) => ({ ...i, [t.name]: t.startTime }), {});
}, z = () => {
  if (typeof window.performance.getEntriesByType == "function" && window.performance.getEntriesByType("resource") != null && window.performance.getEntriesByType("resource").length > 0) {
    const n = window.performance.getEntriesByType(
      "resource"
    ), i = n.reduce(
      (o, r) => o + r.transferSize,
      0
    ), t = n.reduce(
      (o, r) => o + r.encodedBodySize,
      0
    ), a = n.reduce(
      (o, r) => o + r.decodedBodySize,
      0
    );
    return {
      transferSize: i,
      encodedBodySize: t,
      decodedBodySize: a
    };
  } else
    return;
}, Ve = () => {
  const e = new FormData(), n = z(), i = J(), t = j(), a = U(), o = {
    locale: window.OP_METRICS.locale,
    referrer: window.OP_METRICS.referrer,
    pathname: window.OP_METRICS.id,
    template: window.OP_METRICS.template,
    screenWidth: window.OP_METRICS.screen_width,
    screenHeight: window.OP_METRICS.screen_height,
    version: window.OP_METRICS.site_version
  }, r = {};
  return a !== void 0 && (r.rtt = a.rtt, r.saveData = a.saveData, r.effectiveType = a.effectiveType), i != null && (i["first-contentful-paint"] != null && (r.firstContentfulPaint = i["first-contentful-paint"]), i["first-paint"] != null && (r.firstPaint = i["first-paint"])), r.transferSize = n == null ? void 0 : n.transferSize, r.encodedBodySize = n == null ? void 0 : n.encodedBodySize, r.decodedBodySize = n == null ? void 0 : n.decodedBodySize, e.append("metadata", JSON.stringify(o)), e.append("timeline", JSON.stringify(t)), e.append("optional", JSON.stringify(r)), K(e);
};
function K(e) {
  const n = new XMLHttpRequest();
  if (n.open("POST", "/7", !0), n.setRequestHeader("x-csrf-token", M()), e != null)
    return n.send(e);
}
const T = (e, n) => {
  const i = n;
  if (typeof window.navigator == "object" && typeof window.navigator.sendBeacon == "function") {
    const t = q(i);
    try {
      if (window.navigator.sendBeacon(e, t))
        return;
    } catch {
      R(e, i);
    }
  } else
    try {
      R(e, i);
    } catch {
      Q(e, i);
    }
}, Q = (e, n) => {
  const i = b(n), t = new Image();
  return t.src = `https://${window.location.host}/${e}?${i}`, t;
}, q = (e) => {
  const n = e, i = new FormData();
  if (i.append("authenticity_token", M()), typeof Object.entries == "function")
    for (const [t, a] of Object.entries(n))
      i.append(t, a);
  else
    B(n).forEach((a) => {
      i.append(a[0], a[1]);
    });
  return i;
}, xe = (e, n) => {
  new IntersectionObserver(
    (t, a) => {
      Array.prototype.slice.call(t).forEach(function(o) {
        var r;
        if (o.isIntersecting) {
          const c = {
            locale: window.OP_METRICS.locale,
            pathname: window.OP_METRICS.id,
            referrer: window.OP_METRICS.referrer,
            screenHeight: window.OP_METRICS.screen_height,
            screenWidth: window.OP_METRICS.screen_width,
            version: window.OP_METRICS.site_version,
            template: window.OP_METRICS.template,
            elementSelector: n.type === "data" ? n.name + "_" + ((r = o.target) == null ? void 0 : r.getAttribute("data-" + n.name)) : n.name,
            timeSeen: o.time.toString()
          };
          a.disconnect(), T("/3", c);
        }
      });
    }
  ).observe(e);
}, _ = (e) => {
  const n = "/5", i = e, t = {
    locale: window.OP_METRICS.locale,
    referrer: window.OP_METRICS.referrer,
    pathname: window.OP_METRICS.id,
    template: window.OP_METRICS.template,
    screenWidth: window.OP_METRICS.screen_width,
    screenHeight: window.OP_METRICS.screen_height,
    version: window.OP_METRICS.site_version,
    eventType: i,
    end: String(performance.now())
  };
  T(n, t);
}, Ge = () => {
  L() === "Mobile" && document.addEventListener("visibilitychange", (i) => {
    document.visibilityState === "hidden" && _(i == null ? void 0 : i.type);
  });
  const n = ["beforeunload", "unload"];
  "onpagehide" in self && n.unshift("pagehide"), n.forEach(
    (i) => window.addEventListener(i, (t) => _(t == null ? void 0 : t.type), !0)
  );
}, He = () => {
  const e = L();
  let n = "touchstart";
  e === "Desktop" && (n = "click"), Array.from(document.getElementsByTagName("a")).forEach((t) => {
    t.addEventListener(n, () => {
      var r;
      const a = t.className, o = (r = t.parentElement) == null ? void 0 : r.className;
      return $(a, o);
    });
  });
};
function $(e, n) {
  const i = "/4", t = {
    elementSelector: e,
    parentSelector: n,
    locale: window.OP_METRICS.locale,
    pathname: window.OP_METRICS.id,
    referrer: window.OP_METRICS.referrer,
    screenHeight: window.OP_METRICS.screen_height,
    screenWidth: window.OP_METRICS.screen_width,
    version: window.OP_METRICS.site_version,
    template: window.OP_METRICS.template
  };
  T(i, t);
}
const Ne = (e) => {
  e.addEventListener("click", () => {
    const n = window.OP_METRICS.id, i = window.OP_METRICS.locale;
    n != null && i != null && S(
      "GET",
      `/click_more_click_counts?id=${n}&locale=${i}`,
      void 0
    ), e.style.display = "none";
  });
}, Oe = (e) => {
  new IntersectionObserver(
    (i, t) => {
      Array.prototype.forEach.call(
        i,
        (a) => {
          if (a.isIntersecting) {
            const o = window.OP_METRICS.id, r = window.OP_METRICS.locale;
            o != null && r != null && S(
              "GET",
              `/click_more_view_counts?id=${o}&locale=${r}`,
              void 0
            ), t.disconnect();
          }
        }
      );
    }
  ).observe(e);
}, We = () => {
  const e = window.metricsConfig.gTag_container_ID;
  e != null ? function(n) {
    window[n] == null && (window[n] = []), window[n].push({
      "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
      event: "gtm.js"
    });
    const i = document.getElementsByTagName(
      "script"
    )[0], t = document.createElement("script"), a = "";
    t.async = !1, t.src = "https://www.googletagmanager.com/gtm.js?id=" + e + a, i != null && (i.parentNode != null ? i.parentNode.insertBefore(t, i) : i.insertBefore(t, i));
  }("dataLayer") : console.error("The gTag container ID did not load properly");
}, ee = () => {
  if (matchMedia("(dynamic-range: high)").matches)
    return !0;
  if (matchMedia("(dynamic-range: standard)").matches)
    return !1;
}, te = () => {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}, ne = () => {
  const e = window.navigator;
  return {
    s_cD: window.screen.colorDepth,
    dM: e.deviceMemory,
    hCc: e.hardwareConcurrency,
    hdr: ee(),
    osCpu: e.oscpu ? e.oscpu : !1,
    pVE: e.pdfViewerEnabled,
    sS: te(),
    u_a: e.userAgent,
    //user_agent
    t_z_o: (/* @__PURE__ */ new Date()).getTimezoneOffset(),
    // time_zone_offset
    dnt: e.doNotTrack !== null,
    // do_not_track
    lang: e.language !== null ? e.language : null
    // language 
  };
};
class ie {
  constructor() {
    g(this, "baseFonts");
    g(this, "defaultWidth", {});
    g(this, "defaultHeight", {});
    g(this, "span", document.createElement("span"));
    g(this, "body", document.getElementsByTagName("body")[0]);
    this.baseFonts = ["monospace", "sans-serif", "serif"];
    const n = "mmmmmmmmmmlli", i = "72px";
    this.span.style.fontSize = i, this.span.innerHTML = n, this.baseFonts.forEach((t) => {
      this.span.style.fontFamily = t, this.body.appendChild(this.span), this.defaultWidth[t] = this.span.offsetWidth, this.defaultHeight[t] = this.span.offsetHeight, this.body.removeChild(this.span);
    });
  }
  // a font will be compared against all the three default fonts.
  // and if it doesn't match all 3 then that font is not available.
  detect(n) {
    let i = !1;
    return this.baseFonts.forEach((t) => {
      this.span.style.fontFamily = String(n) + "," + String(t), this.body.appendChild(this.span);
      const a = this.span.offsetWidth !== this.defaultWidth[t] || this.span.offsetHeight !== this.defaultHeight[t];
      this.body.removeChild(this.span), i = i || a;
    }), i;
  }
}
const re = () => {
  const e = new ie(), n = ["Abadi MT Condensed Light", "Adobe Fangsong Std", "Adobe Hebrew", "Adobe Ming Std", "Agency FB", "Aharoni", "Andalus", "Angsana New", "AngsanaUPC", "Aparajita", "Arab", "Arabic Transparent", "Arabic Typesetting", "Arial Baltic", "Arial Black", "Arial CE", "Arial CYR", "Arial Greek", "Arial TUR", "Arial", "Batang", "BatangChe", "Bauhaus 93", "Bell MT", "Bitstream Vera Serif", "Bodoni MT", "Bookman Old Style", "Braggadocio", "Broadway", "Browallia New", "BrowalliaUPC", "Calibri Light", "Calibri", "Californian FB", "Cambria Math", "Cambria", "Candara", "Castellar", "Casual", "Centaur", "Century Gothic", "Chalkduster", "Colonna MT", "Comic Sans MS", "Consolas", "Constantia", "Copperplate Gothic Light", "Corbel", "Cordia New", "CordiaUPC", "Courier New Baltic", "Courier New CE", "Courier New CYR", "Courier New Greek", "Courier New TUR", "Courier New", "DFKai-SB", "DaunPenh", "David", "DejaVu LGC Sans Mono", "Desdemona", "DilleniaUPC", "DokChampa", "Dotum", "DotumChe", "Ebrima", "Engravers MT", "Eras Bold ITC", "Estrangelo Edessa", "EucrosiaUPC", "Euphemia", "Eurostile", "FangSong", "Forte", "FrankRuehl", "Franklin Gothic Heavy", "Franklin Gothic Medium", "FreesiaUPC", "French Script MT", "Gabriola", "Gautami", "Georgia", "Gigi", "Gisha", "Goudy Old Style", "Gulim", "GulimChe", "GungSeo", "Gungsuh", "GungsuhChe", "Haettenschweiler", "Harrington", "Hei S", "HeiT", "Heisei Kaku Gothic", "Hiragino Sans GB", "Impact", "Informal Roman", "IrisUPC", "Iskoola Pota", "JasmineUPC", "KacstOne", "KaiTi", "Kalinga", "Kartika", "Khmer UI", "Kino MT", "KodchiangUPC", "Kokila", "Kozuka Gothic Pr6N", "Lao UI", "Latha", "Leelawadee", "Levenim MT", "LilyUPC", "Lohit Gujarati", "Loma", "Lucida Bright", "Lucida Console", "Lucida Fax", "Lucida Sans Unicode", "MS Gothic", "MS Mincho", "MS PGothic", "MS PMincho", "MS Reference Sans Serif", "MS UI Gothic", "MV Boli", "Magneto", "Malgun Gothic", "Mangal", "Marlett", "Matura MT Script Capitals", "Meiryo UI", "Meiryo", "Menlo", "Microsoft Himalaya", "Microsoft JhengHei", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Sans Serif", "Microsoft Tai Le", "Microsoft Uighur", "Microsoft YaHei", "Microsoft Yi Baiti", "MingLiU", "MingLiU-ExtB", "MingLiU_HKSCS", "MingLiU_HKSCS-ExtB", "Miriam Fixed", "Miriam", "Mongolian Baiti", "MoolBoran", "NSimSun", "Narkisim", "News Gothic MT", "Niagara Solid", "Nyala", "PMingLiU", "PMingLiU-ExtB", "Palace Script MT", "Palatino Linotype", "Papyrus", "Perpetua", "Plantagenet Cherokee", "Playbill", "Prelude Bold", "Prelude Condensed Bold", "Prelude Condensed Medium", "Prelude Medium", "PreludeCompressedWGL Black", "PreludeCompressedWGL Bold", "PreludeCompressedWGL Light", "PreludeCompressedWGL Medium", "PreludeCondensedWGL Black", "PreludeCondensedWGL Bold", "PreludeCondensedWGL Light", "PreludeCondensedWGL Medium", "PreludeWGL Black", "PreludeWGL Bold", "PreludeWGL Light", "PreludeWGL Medium", "Raavi", "Rachana", "Rockwell", "Rod", "Sakkal Majalla", "Sawasdee", "Script MT Bold", "Segoe Print", "Segoe Script", "Segoe UI Light", "Segoe UI Semibold", "Segoe UI Symbol", "Segoe UI", "Shonar Bangla", "Showcard Gothic", "Shruti", "SimHei", "SimSun", "SimSun-ExtB", "Simplified Arabic Fixed", "Simplified Arabic", "Snap ITC", "Sylfaen", "Symbol", "Tahoma", "Times New Roman Baltic", "Times New Roman CE", "Times New Roman CYR", "Times New Roman Greek", "Times New Roman TUR", "Times New Roman", "TlwgMono", "Traditional Arabic", "Trebuchet MS", "Tunga", "Tw Cen MT Condensed Extra Bold", "Ubuntu", "Umpush", "Univers", "Utopia", "Utsaah", "Vani", "Verdana", "Vijaya", "Vladimir Script", "Vrinda", "Webdings", "Wide Latin", "Wingdings"];
  let i = "";
  for (let t = 0; t < n.length; t++)
    e.detect(n[t]) && (t === n.length - 1 ? i += n[t] : i += n[t] + ", ");
  return { fts: i };
}, ae = () => {
  const e = document.createElement("canvas");
  e.hidden = !0, document.body.appendChild(e);
  const n = Array.from(document.getElementsByTagName("canvas"));
  if (n !== null && typeof n < "u") {
    const i = n[0].getContext("webgl"), t = i == null ? void 0 : i.getExtension("WEBGL_debug_renderer_info");
    return {
      v: t != null ? i == null ? void 0 : i.getParameter(t.UNMASKED_VENDOR_WEBGL) : null,
      r: t != null ? i == null ? void 0 : i.getParameter(t.UNMASKED_RENDERER_WEBGL) : null,
      webGL: oe(i)
    };
  }
  return {};
};
function oe(e) {
  const n = function(u) {
    return e.clearColor(0, 0, 0, 1), e.enable(e.DEPTH_TEST), e.depthFunc(e.LEQUAL), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT), "[" + String(u[0]) + ", " + String(u[1]) + "]";
  }, i = function(u) {
    let f, h;
    return u.getExtension("EXT_texture_filter_anisotropic") !== null ? h = u.getExtension("EXT_texture_filter_anisotropic") : u.getExtension("WEBKIT_EXT_texture_filter_anisotropic") !== null ? h = u.getExtension("WEBKIT_EXT_texture_filter_anisotropic") : u.getExtension("MOZ_EXT_texture_filter_anisotropic") !== null ? h = u.getExtension("MOZ_EXT_texture_filter_anisotropic") : h = null, f = Number(u.getParameter(h.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), h !== null ? (Number(u.getParameter(h.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), f === 0 && (f = 2), f) : null;
  }, t = [], a = "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}", o = "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}", r = e.createBuffer();
  e.bindBuffer(e.ARRAY_BUFFER, r);
  const c = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);
  e.bufferData(e.ARRAY_BUFFER, c, e.STATIC_DRAW), r.itemSize = 3, r.numItems = 3;
  const s = e.createProgram(), m = e.createShader(e.VERTEX_SHADER);
  e.shaderSource(m, a), e.compileShader(m);
  const p = e.createShader(e.FRAGMENT_SHADER);
  return e.shaderSource(p, o), e.compileShader(p), e.attachShader(s, m), e.attachShader(s, p), e.linkProgram(s), e.useProgram(s), s.vertexPosAttrib = e.getAttribLocation(s, "attrVertex"), s.offsetUniform = e.getUniformLocation(s, "uniformOffset"), e.enableVertexAttribArray(s.vertexPosArray), e.vertexAttribPointer(s.vertexPosAttrib, r.itemSize, e.FLOAT, !1, 0, 0), e.uniform2f(s.offsetUniform, 1, 1), e.drawArrays(e.TRIANGLE_STRIP, 0, r.numItems), t.push("extensions:" + String(e.getSupportedExtensions().join(";"))), t.push("webgl aliased line width range:" + String(n(e.getParameter(e.ALIASED_LINE_WIDTH_RANGE)))), t.push("webgl aliased point size range:" + String(n(e.getParameter(e.ALIASED_POINT_SIZE_RANGE)))), t.push("webgl alpha bits:" + String(e.getParameter(e.ALPHA_BITS))), t.push("webgl antialiasing:" + (e.getContextAttributes().antialias !== null ? "yes" : "no")), t.push("webgl blue bits:" + String(e.getParameter(e.BLUE_BITS))), t.push("webgl depth bits:" + String(e.getParameter(e.DEPTH_BITS))), t.push("webgl green bits:" + String(e.getParameter(e.GREEN_BITS))), t.push("webgl max anisotropy:" + String(i(e))), t.push("webgl max combined texture image units:" + String(e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS))), t.push("webgl max cube map texture size:" + String(e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE))), t.push("webgl max fragment uniform vectors:" + String(e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS))), t.push("webgl max render buffer size:" + String(e.getParameter(e.MAX_RENDERBUFFER_SIZE))), t.push("webgl max texture image units:" + String(e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS))), t.push("webgl max texture size:" + String(e.getParameter(e.MAX_TEXTURE_SIZE))), t.push("webgl max varying vectors:" + String(e.getParameter(e.MAX_VARYING_VECTORS))), t.push("webgl max vertex attribs:" + String(e.getParameter(e.MAX_VERTEX_ATTRIBS))), t.push("webgl max vertex texture image units:" + String(e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS))), t.push("webgl max vertex uniform vectors:" + String(e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS))), t.push("webgl max viewport dims:" + String(n(e.getParameter(e.MAX_VIEWPORT_DIMS)))), t.push("webgl red bits:" + String(e.getParameter(e.RED_BITS))), t.push("webgl renderer:" + String(e.getParameter(e.RENDERER))), t.push("webgl shading language version:" + String(e.getParameter(e.SHADING_LANGUAGE_VERSION))), t.push("webgl stencil bits:" + String(e.getParameter(e.STENCIL_BITS))), t.push("webgl vendor:" + String(e.getParameter(e.VENDOR))), t.push("webgl version:" + String(e.getParameter(e.VERSION))), t.push("webgl vertex shader high float precision:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision)), t.push("webgl vertex shader high float precision rangeMin:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).rangeMin)), t.push("webgl vertex shader high float precision rangeMax:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).rangeMax)), t.push("webgl vertex shader medium float precision:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision)), t.push("webgl vertex shader medium float precision rangeMin:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).rangeMin)), t.push("webgl vertex shader medium float precision rangeMax:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).rangeMax)), t.push("webgl vertex shader low float precision:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.LOW_FLOAT).precision)), t.push("webgl vertex shader low float precision rangeMin:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.LOW_FLOAT).rangeMin)), t.push("webgl vertex shader low float precision rangeMax:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.LOW_FLOAT).rangeMax)), t.push("webgl fragment shader high float precision:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision)), t.push("webgl fragment shader high float precision rangeMin:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).rangeMin)), t.push("webgl fragment shader high float precision rangeMax:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).rangeMax)), t.push("webgl fragment shader medium float precision:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision)), t.push("webgl fragment shader medium float precision rangeMin:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).rangeMin)), t.push("webgl fragment shader medium float precision rangeMax:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).rangeMax)), t.push("webgl fragment shader low float precision:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.LOW_FLOAT).precision)), t.push("webgl fragment shader low float precision rangeMin:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.LOW_FLOAT).rangeMin)), t.push("webgl fragment shader low float precision rangeMax:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.LOW_FLOAT).rangeMax)), t.push("webgl vertex shader high int precision:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_INT).precision)), t.push("webgl vertex shader high int precision rangeMin:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_INT).rangeMin)), t.push("webgl vertex shader high int precision rangeMax:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_INT).rangeMax)), t.push("webgl vertex shader medium int precision:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_INT).precision)), t.push("webgl vertex shader medium int precision rangeMin:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_INT).rangeMin)), t.push("webgl vertex shader medium int precision rangeMax:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_INT).rangeMax)), t.push("webgl vertex shader low int precision:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.LOW_INT).precision)), t.push("webgl vertex shader low int precision rangeMin:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.LOW_INT).rangeMin)), t.push("webgl vertex shader low int precision rangeMax:" + String(e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.LOW_INT).rangeMax)), t.push("webgl fragment shader high int precision:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_INT).precision)), t.push("webgl fragment shader high int precision rangeMin:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_INT).rangeMin)), t.push("webgl fragment shader high int precision rangeMax:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_INT).rangeMax)), t.push("webgl fragment shader medium int precision:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_INT).precision)), t.push("webgl fragment shader medium int precision rangeMin:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_INT).rangeMin)), t.push("webgl fragment shader medium int precision rangeMax:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_INT).rangeMax)), t.push("webgl fragment shader low int precision:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.LOW_INT).precision)), t.push("webgl fragment shader low int precision rangeMin:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.LOW_INT).rangeMin)), t.push("webgl fragment shader low int precision rangeMax:" + String(e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.LOW_INT).rangeMax)), e.canvas != null && t.push(e.canvas.toDataURL()), t;
}
function w(e) {
  return e.reduce((n, i) => n + (i ? 1 : 0), 0);
}
const se = async () => {
  if (!ce())
    return {
      domBlockers: {
        undefined: void 0
      }
    };
  const e = he(), n = Object.keys(e), i = [].concat(...n.map((o) => e[o])), t = await pe(i), a = n.filter((o) => {
    const r = e[o];
    return w(r.map((s) => t[s])) > r.length * 0.6;
  });
  return a.sort(), {
    domBlockers: {
      activeBlockers: a
    }
  };
};
function ce() {
  return le() || ue();
}
function de() {
  var n;
  const e = window;
  return w([
    "buildID" in navigator,
    "MozAppearance" in (((n = document.documentElement) == null ? void 0 : n.style) ?? {}),
    "onmozfullscreenchange" in e,
    "mozInnerScreenX" in e,
    "CSSMozDocumentRule" in e,
    "CanvasCaptureMediaStream" in e
  ]) >= 4;
}
function le() {
  const e = window, n = navigator;
  return w([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    n.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in n,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function me() {
  const e = window, n = navigator;
  return w([
    "webkitPersistentStorage" in n,
    "webkitTemporaryStorage" in n,
    n.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function ue() {
  const e = me(), n = de(), i = window, t = navigator;
  return e ? w([
    !("SharedWorker" in i),
    // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
    // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
    // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
    t.connection && "ontypechange" in t.connection,
    !("sinkId" in new window.Audio())
  ]) >= 2 : n ? w(["onorientationchange" in i, "orientation" in i, /android/i.test(navigator.appVersion)]) >= 2 : !1;
}
function he() {
  const e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e(
        "YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="
      ),
      e(
        "YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ=="
      )
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function v(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
async function pe(e) {
  var o;
  const n = document, i = n.createElement("div"), t = new Array(e.length), a = {};
  v(i);
  for (let r = 0; r < e.length; ++r) {
    const c = fe(e[r]);
    c.tagName === "DIALOG" && c.show();
    const s = n.createElement("div");
    v(s), s.appendChild(c), i.appendChild(s), t[r] = c;
  }
  for (; !n.body; )
    await P(50);
  n.body.appendChild(i), await P(0);
  try {
    for (let r = 0; r < e.length; ++r)
      t[r].offsetParent || (a[e[r]] = !0);
  } finally {
    (o = i.parentNode) == null || o.removeChild(i);
  }
  return a;
}
function fe(e) {
  const [n, i] = we(e), t = document.createElement(n ?? "div");
  for (const a of Object.keys(i)) {
    const o = i[a].join(" ");
    a === "style" ? ge(t.style, o) : t.setAttribute(a, o);
  }
  return t;
}
function ge(e, n) {
  for (const i of n.split(";")) {
    const t = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(i);
    if (t) {
      const [, a, o, , r] = t;
      e.setProperty(a, o, r || "");
    }
  }
}
function we(e) {
  const n = `Unexpected syntax '${e}'`, i = /^\s*([a-z-]*)(.*)$/i.exec(e), t = i[1] || void 0, a = {}, o = /([.:#][\w-]+|\[.+?\])/gi, r = (c, s) => {
    a[c] = a[c] || [], a[c].push(s);
  };
  for (; ; ) {
    const c = o.exec(i[2]);
    if (!c)
      break;
    const s = c[0];
    switch (s[0]) {
      case ".":
        r("class", s.slice(1));
        break;
      case "#":
        r("id", s.slice(1));
        break;
      case "[": {
        const m = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(s);
        if (m)
          r(m[1], m[4] ?? m[5] ?? "");
        else
          throw new Error(n);
        break;
      }
      default:
        throw new Error(n);
    }
  }
  return [t, a];
}
function P(e, n) {
  return new Promise((i) => setTimeout(i, e, n));
}
const Se = async () => {
  const e = window.OfflineAudioContext ?? window.webkitOfflineAudioContext, n = new e(1, 5e3, 44100), i = n.createOscillator();
  i.type = "triangle", i.frequency.value = 1e3;
  const t = n.createDynamicsCompressor();
  return t.threshold.value = -50, t.knee.value = 40, t.ratio.value = 12, t.attack.value = 0, t.release.value = 0.2, i.connect(t), t.connect(n.destination), i.start(), await new Promise((o) => {
    n.oncomplete = (r) => {
      o({ a: be(r.renderedBuffer.getChannelData(0)) });
    }, n.startRendering().catch((r) => {
      console.log(r);
    });
  });
};
function be(e) {
  let n = 0;
  for (let i = 0; i < e.length; ++i)
    n += Math.abs(e[i]);
  return n;
}
const ye = () => {
  const e = navigator.plugins;
  if (!e)
    return;
  const n = [];
  for (let i = 0; i < e.length; ++i) {
    const t = e[i];
    if (!t)
      continue;
    const a = [];
    for (let o = 0; o < t.length; ++o) {
      const r = t[o];
      a.push({
        type: r.type,
        suffixes: r.suffixes
      });
    }
    n.push({
      name: t.name,
      description: t.description,
      mimeTypes: a
    });
  }
  return { plugins: n };
}, l = () => 0, Ee = () => {
  const e = Math.acos || l, n = Math.acosh || l, i = Math.asin || l, t = Math.asinh || l, a = Math.atanh || l, o = Math.atan || l, r = Math.sin || l, c = Math.sinh || l, s = Math.cos || l, m = Math.cosh || l, p = Math.tan || l, u = Math.tanh || l, f = Math.exp || l, h = Math.expm1 || l, I = Math.log1p || l, A = (d) => Math.pow(Math.PI, d), C = (d) => Math.log(d + Math.sqrt(d * d - 1)), F = (d) => Math.log(d + Math.sqrt(d * d + 1)), k = (d) => Math.log((1 + d) / (1 - d)) / 2, V = (d) => Math.exp(d) - 1 / Math.exp(d) / 2, x = (d) => (Math.exp(d) + 1 / Math.exp(d)) / 2, G = (d) => Math.exp(d) - 1, H = (d) => (Math.exp(2 * d) - 1) / (Math.exp(2 * d) + 1), N = (d) => Math.log(1 + d);
  return {
    m: {
      acos: e(0.12312423423423424),
      acosh: n(1e308),
      acoshPf: C(1e154),
      // 1e308 will not work for polyfill
      asin: i(0.12312423423423424),
      asinh: t(1),
      asinhPf: F(1),
      atanh: a(0.5),
      atanhPf: k(0.5),
      atan: o(0.5),
      sin: r(-1e300),
      sinh: c(1),
      sinhPf: V(1),
      cos: s(10.000000000123),
      cosh: m(1),
      coshPf: x(1),
      tan: p(-1e300),
      tanh: u(1),
      tanhPf: H(1),
      exp: f(1),
      expm1: h(1),
      expm1Pf: G(1),
      log1p: I(10),
      log1pPf: N(10),
      powPI: A(-100)
    }
  };
}, Me = () => {
  const { ApplePaySession: e } = window;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return {
      aP: -1
    };
  try {
    return {
      aP: e.canMakePayments() ? 1 : 0
    };
  } catch (n) {
    return Te(n);
  }
};
function Te(e) {
  if (e instanceof Error) {
    if (e.name === "InvalidAccessError") {
      if (/\bfrom\b.*\binsecure\b/i.test(e.message))
        return {
          aP: -2
        };
      if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(e.message))
        return {
          aP: -3
        };
    }
    if (e.name === "SecurityError" && /\bthird.party iframes?.*\bnot.allowed\b/i.test(e.message))
      return {
        aP: -3
      };
  }
  throw e;
}
const Re = () => {
  const e = navigator;
  let n = 0, i = !1;
  e.maxTouchPoints !== void 0 && (n = Number(e.maxTouchPoints));
  try {
    document.createEvent("TouchEvent"), i = !0;
  } catch {
  }
  const t = "ontouchstart" in window;
  return {
    touch: {
      maxTouchPts: n,
      touchEvent: i,
      touchStart: t
    }
  };
}, Xe = async () => await Promise.all([ne(), Se(), re(), ae(), se(), ye(), Ee(), Me(), Re()]).then((e) => {
  let n = {};
  e.map((a) => n = { ...n, ...a });
  let i = {};
  i = Object.keys(n).sort().reduce((a, o) => (a[o] = n[o], a), {});
  const t = {
    locale: window.OP_METRICS.locale,
    pathname: document.location.pathname,
    referrer: window.OP_METRICS.referrer,
    fingerprint: JSON.stringify(i)
  };
  S("POST", "/6", b(t));
}), De = () => {
  const e = {
    site: window.OP_METRICS.site,
    locale: window.OP_METRICS.locale,
    type: window.OP_METRICS.type,
    id: window.OP_METRICS.id,
    referrer: document.referrer
  }, n = [];
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (e[t] !== "" || e[t] === void 0) && n.push(
      encodeURIComponent(t) + "=" + encodeURIComponent(e[t])
    );
  const i = n.join("&");
  try {
    S("GET", `/1?${i}`, void 0);
  } catch {
    const a = new Image();
    a.src = `https://${window.location.host}/1?${i}`;
  }
};
export {
  ve as currentLocale,
  Pe as currentPage,
  Le as currentTemplate,
  Ie as currentVersion,
  xe as elementImpression,
  Xe as fingerprint,
  We as gTag,
  He as linkTracking,
  Ve as performanceAnalyticsData,
  De as readAnalytics,
  Ne as readMoreClick,
  Oe as readMoreViewed,
  Ae as screenHeight,
  Ce as screenWidth,
  ke as scrollDepth,
  Fe as sendAPIResults,
  Ge as timeOnPage
};
